import React, {Component} from 'react';
import {Mutation} from 'react-apollo';
import css from './usersTable.scss';
import Popup from '../popup/popup';
import {GET_USERS, DELETE_USER} from './queries';

class DeleteUser extends Component {
	updateCache = cache => {
		const data = cache.readQuery({query: GET_USERS});
		data.users = data.users.filter(({id}) => id !== this.props.userId);
		cache.writeQuery({query: GET_USERS, data});
	};
	render() {
		return (
			<Mutation
				mutation={DELETE_USER}
				variables={{id: this.props.userId}}
				update={this.updateCache}
			>
				{(deleteUser, {loading, error}) => {
					return [
						<button
							key="btn"
							className={css.delete}
							type="button"
							onClick={_ => this.popup.open()}
						/>,
						<Popup
							key="popup"
							ref={n => (this.popup = n)}
							onConfirm={_ => deleteUser()}
						>
							Attention&nbsp;! Vous êtes sur le point de supprimer
							un utilisateur. Êtes-vous sûr&nbsp;?
						</Popup>,
					];
				}}
			</Mutation>
		);
	}
}

export default DeleteUser;



// WEBPACK FOOTER //
// ./src/components/usersTable/deleteUser.js